<template>
  <div v-if="dataLoaded">

    <!-- Row top buttons -->
    <div class="row q-mb-lg">
      <div class="col-6" style="justify-content: flex-start">
        <q-btn
          class="capitalize ctrl-button"
          color="grey-5"
          :label="`${$store.state.stringsStore.strings.action.toOverview}`"
          @click="$router.push(`/faq`)"
          icon="keyboard_backspace"
        />
      </div>

      <div class="col-6">
        <q-btn
          v-if="$store.state.meStore.me.rights.includes(`faq.category.edit`) || $store.state.meStore.me.su"
          class="capitalize ctrl-button right q-ml-md"
          :color="readOnly ? 'grey-5' :'ctrl-turquoise'"
          :label="readOnly ? getString('action.edit') : getString('action.save')"
          @click="saveChanges()"
          :icon-right="readOnly ? 'edit' : 'save'"
        />
        <q-btn
          v-if="data.id && ($store.state.meStore.me.rights.includes(`faq.category.delete`) || $store.state.meStore.me.su)"
          class="q-ml-md capitalize ctrl-button right"
          icon-right="delete"
          color="negative capitalize"
          :label="$store.state.stringsStore.strings.action.delete"
          @click="deleteCategory()"
          align="right"
        />
      </div>
    </div>

    <div class="row gutter-sm q-mb-lg">
      <!-- General Information -->
      <div class="col-md-6 col-sm-12 col-xs-12">
        <p class="card-title">
          {{ getString('category') }}
        </p>
        <div class="card-block">
          <!-- Name -->
          <q-field class="q-mb-md">
            <q-input type="text" v-model="data.name"
              @input="suggestUrl"
              :disable="readOnly"
              :readonly="readOnly"
              :float-label="getString('name')">
            </q-input>
          </q-field>
          <!-- Url -->
          <q-field class="q-mb-md">
            <q-input type="text" v-model="data.url"
              @input="setUrl"
              :disable="readOnly"
              :readonly="readOnly"
              :float-label="getString('url')">
            </q-input>
          </q-field>
          <!-- Relation -->
          <q-field class="q-mb-md" v-if="data.relation">
            <q-search :readonly="readOnly" :disable="readOnly"  clearable v-model="data.relation.name" float-label="Relation" @clear="data.relation = { id: null, name: ''}">
              <q-autocomplete :max-results="25" value-field="name" :min-characters="2" @search="searchRelation" @selected="selectRelation"/>
            </q-search>
          </q-field>

          <q-field class="q-mb-md">
            <div class="row">
              <div class="col-md-3 q-pr-md">
                <q-toggle
                  :disable="readOnly"
                  :readonly="readOnly"
                  class="q-mt-lg" color="secondary" label="Subcategory" v-model="subcategory" />
              </div>
              <div class="col-md-9 q-pl-md">
                <q-select v-if="subcategory"
                  :disable="readOnly"
                  :readonly="readOnly"
                  v-model="data.parent_id"
                  float-label="Parent category"
                  :options="categoryOptions" />
              </div>
            </div>
          </q-field>
        </div>
      </div>

      <!-- Meta -->
      <div class="col-md-6 col-sm-12 col-xs-12 q-pl-sm">
        <div class="row q-mb-sm">
          <div class="full-width">
            <p class="card-title">
              {{ 'Meta' }}
            </p>

            <div class="card-block">
              <div class="row">
                <q-input
                  :disable="readOnly"
                  :readonly="readOnly"
                  type="text"
                  class="full-width q-mb-md"
                  :float-label="getString('editor.meta.seo.title')"
                  v-model="data.meta.seo.title"
                />
                <q-input
                  :disable="readOnly"
                  :readonly="readOnly"
                  type="text"
                  class="full-width q-mb-md"
                  :float-label="getString('editor.meta.seo.description')"
                  v-model="data.meta.seo.description"
                />
                <q-input
                  :disable="readOnly"
                  :readonly="readOnly"
                  type="text"
                  class="full-width q-mb-md"
                  :float-label="getString('editor.meta.og.title')"
                  v-model="data.meta.og.title"
                />
                <q-input
                  :disable="readOnly"
                  :readonly="readOnly"
                  type="text"
                  class="full-width q-mb-md"
                  :float-label="getString('editor.meta.og.description')"
                  v-model="data.meta.og.description"
                />
                <q-input
                  :disable="readOnly"
                  :readonly="readOnly"
                  type="text"
                  class="full-width q-mb-md"
                  :float-label="getString('editor.meta.canonical')"
                  v-model="data.meta.canonical"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import qs from 'qs';
import fetchDetail from '@/mixins/detailViews/fetchDetail';
import saveChanges from '@/mixins/detailViews/saveChanges';
import suggestUrl from '@/mixins/suggestUrl';
import getString from '@/helpers/GetStrings';
import common from '../common';

export default {
  data() {
    return {
      dataLoaded: false,
      subcategory: false,
      categoryOptions: [],
      data: {
        id: null,
        name: '',
        url: '',
        relation: {
          id: null,
          name: '',
        },
        meta: {
          seo: {
            description: '',
            title: '',
          },
          og: {
            description: '',
            title: '',
          },
          canonical: '',
        },
      },
    };
  },
  mixins: [
    suggestUrl,
    fetchDetail,
    saveChanges,
    common,
  ],
  methods: {
    getString,


    /**
     * Search for pages using the autocomplete
     */
     searchRelation(terms, done) {

      this.axios.get(`relation?autocomplete=${terms}`).then((response) => {
        const suggestions = response.data.relations.map(item => ({ label: item.name, id: item.id }));
        done(suggestions);
      });
    },

    selectRelation(found, keyboard) {
      // Prevent adding on keyboard arrow down
      if (keyboard) return;
      this.data.relation = {
        id: found.id,
        name: found.label,
      };
    },

    deleteCategory() {
      // Dialog
      this.$q.dialog({
        title: '',
        message: this.getString('module.library.delete.title.single'),
        ok: this.$store.state.stringsStore.strings.dialog.confirm.ok,
        cancel: this.$store.state.stringsStore.strings.dialog.confirm.cancel,
      }).then(() => {
        // delete call
        this.axios.delete(`faq/category/${this.data.id}`)
          .then(() => {
            // Refresh data to see the result
            this.$q.notify({
              message: this.getString('upload.delete.success').replace('%file%', this.getString('category')),
              position: 'top-right',
              timeout: 1000,
              color: 'positive',
            });
            this.$router.push('/faq');
          })
          .catch((error) => {
            // Error
            console.warn(error);
          });
      }).catch(() => {
        console.warn('Not removed');
      });
    },

    requestParams() {
      const requiredFields = {
        name: this.data.name,
        url: this.data.url,
      };

      const optional = {
        parent_id: this.subcategory ? this.data.parent_id : null,
        meta_seo_title: this.data.meta.seo.title,
        meta_seo_description: this.data.meta.seo.description,
        meta_og_title: this.data.meta.og.title,
        meta_og_description: this.data.meta.og.description,
        meta_canonical: this.data.meta.canonical,
        relation: this.data.relation ? this.data.relation.id : null,
      };

      // If a value is null, undefined or empty, remove it from fields
      for (const [key, value] of Object.entries(optional)) {
        if (value === null || value === undefined) delete optional[key];
      }

      // Join required and optionals
      const fields = Object.assign(requiredFields, optional);

      return fields;
    },

    toggle(value, param) {
      this.axios.put(`${this.endpoint}/${this.data.id}`, qs.stringify({ [param]: value ? 1 : 0 }));
    },
  },
  watch: {
    'data.parent_id': function (val) {
      if (val) {
        this.subcategory = true;
      }
    },
  },
  filters: {
    checkEmpty(value) {
      return value === null || value === '' ? '-' : value;
    },
    capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },

  async mounted() {
    const res = await this.axios.get('faq/category');
    this.categoryOptions = res.data.categories && res.data.categories
      .filter(category => Number(category.id) !== Number(this.$route.params.id))
      .map(category => ({ value: category.id, label: category.name }));
    if (this.$route.params.id) this.readOnly = true;
    // if relation is null
    if (!this.data.relation) this.data.relation = { id: null, name: '' };
    this.dataLoaded = true;
  },
};
</script>


<style lang="stylus" scoped>
@import '~variables';
.data-title
  font-weight 700

.data-content
  word-break break-all

</style>
